module.exports = __webpack_public_path__ + "assets/img/1.66ba37b2.jpg";